module.exports = __webpack_public_path__ + "img/DropImageIcon.c4f02703.svg";